import Alpine from "alpinejs";

import { session } from "./session";
import { cart } from "./cart";
import { cloud } from "./cloud";
import { GA } from '../analytics/google-analytics'

declare global {
  interface Window {
    Shopify: any;
    Alpine: typeof Alpine;
    cart: typeof cart;
    session: typeof session;
    cloud: typeof cloud;
    SHOPIFY_DATA: ShopifyData;
  }
}

window.cart = cart;
window.session = session;
window.cloud = cloud;
window.Alpine = Alpine;
